import HelpSideNav from "../component/HelpSideNav"
import { useEffect, useState } from "react"
import DocumentationElement from "../documentation/DocumentationElement"
import Documentation from "../documentation/Documentation"
import Card from "../component/Card"
import SmallHeadingComponent from "../component/SmallHeadingComponent"
import { useParams } from "react-router-dom"
import Link from "../component/Link"

function ProfessionalDocumentationView() {
    const [selection, setSelection] = useState<DocumentationElement>(
        Documentation[0]
    )

    const { index, location } = useParams()

    useEffect(() => {
        if (index !== undefined) {
            setSelection(Documentation[Number(index)])
        }
    }, [index])

    return (
        <div className="m-4 flex flex-col space-y-8 mt-8">
            {location !== undefined && (
                <Link to={location}>
                    <div className="text-xl font-bold">Zurück</div>
                </Link>
            )}
            <div className="w-full flex space-x-4">
                <HelpSideNav selection={selection} onSelect={setSelection} />
                {typeof selection.content === "string" ? (
                    <Card fill={true}>
                        <div className="flex flex-col space-y-4">
                            <SmallHeadingComponent>
                                {selection.title}
                            </SmallHeadingComponent>
                            <div className="tracking-widest">
                                {selection.content}
                            </div>

                            {/* Render image if it exists */}
                            {selection.image && (
                                <div className="mt-6 flex justify-center">
                                    <img
                                        src={selection.image}
                                        alt={selection.title}
                                        className="rounded-lg shadow-md max-w-full h-auto"
                                    />
                                </div>
                            )}
                        </div>
                    </Card>
                ) : (
                    selection.content
                )}
            </div>
        </div>
    )
}

export default ProfessionalDocumentationView
